import { render, staticRenderFns } from "./ProjectActionNotificator.vue?vue&type=template&id=c208a472&"
import script from "./ProjectActionNotificator.vue?vue&type=script&lang=js&"
export * from "./ProjectActionNotificator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports